__turbopack_context__.v({
  "subtitle": "HeroTextBlock-module-scss-module__XMJA7W__subtitle",
  "textBlock": "HeroTextBlock-module-scss-module__XMJA7W__textBlock",
  "title": "HeroTextBlock-module-scss-module__XMJA7W__title",
  "titleLine": "HeroTextBlock-module-scss-module__XMJA7W__titleLine",
  "titleLineSecondary": "HeroTextBlock-module-scss-module__XMJA7W__titleLineSecondary",
});
